import IQuestion from './question_interface';

var data3:Array<IQuestion> = [
  {
    id: 'd4521bfd-c63d-41d2-bbe2-a5ed564ae4e7',
    img:'http://data.websitebox.com/data/users/0015/580/uploads/VXQ_fireplacejpg.jpg',
    question: 'How close and warm is your family? Do you feel your childhood was happier than most other people\'s?',
    depth: 3,
    tags: [
      {family: true},
      {childhood: true},
      {memory: true}
    ]
  },
  {
    id: '2e9f3012-297a-42f3-bd31-1e5ad60f3fca',
    img:'http://www.smallbusinessconnect.org/wp-content/uploads/2016/05/mother-429158_1920.jpg',
    question: 'How do you feel about your relationship with your mother?',
    depth: 3,
    tags: [
      {family: true}
    ]
  },
  {
    id: '23ada855-ae90-455f-a901-959c29f17a04',
    img: "https://static.pexels.com/photos/6371/red-love-heart-valentines.jpg",
    question: "List the people you've dated in life.  Say a few words about each relationship.",
    color: "white",
    depth: 3,
    tags: [
      {lovelife: true},
      {history: true}
    ]
  },
  {
    id: 'b186dc2b-6f03-4fc7-bcb0-ecbf58d8fad3',
    img: "https://media.giphy.com/media/nm82hi108J4DC/giphy-facebook_s.jpg",
    question: "How often do you do things out of spite?",
    color: "white",
    depth: 3,
    tags: [
      {personality: true},
      {negative: true}
    ]
  },
  {
    id: '1836cad2-c72f-4497-99df-78af54f198b5',
    img: "https://s-media-cache-ak0.pinimg.com/736x/ae/c1/9f/aec19f14b08aeab81758183ffbd238c5.jpg",
    question: "How do you think your future self will judge the person you are today?",
    color: "white",
    depth: 3,
    tags: [
      {aspirations: true}
    ]
  },
  {
    id: 'd8349ef7-0d37-4085-abdb-16548b3dc7fb',
    img:"https://theconsciousprocess.files.wordpress.com/2013/01/enjoy_the_silence.jpg",
    question: "What do you most regret never telling someone?",
    depth: 3,
    tags: [
      {negative: true},
      {memory: true}
    ]
  },
  {
    id: '1cfeb6c0-6838-42e9-b4f1-14a0d811ce8b',
    img:"http://www.headoverheels.org/wp/wp-content/uploads/2007/02/stan-on-bench.jpg",
    question: "Who in your life do you wish you had met sooner?",
    depth: 3,
    tags: [
      {personality: true}
    ]
  },
  {
    id: 'de3aa25e-2096-487b-82aa-06467d4e1543',
    img:"http://i.huffpost.com/gen/1754564/thumbs/o-LOVE-570.jpg?6",
    question: "Tell the story of your first love.  How did it start?  How did it end?",
    depth: 3,
    tags: [
      {lovelife: true},
      {memory: true}
    ]
  },
  {
    id: 'f76ad266-0bbe-4dea-8a04-c9ef5efba59e',
    img:"http://eskipaper.com/images/field-13.jpg",
    question: "If you knew that in one year you would die suddenly, would you change anything about the way you are now living? Why?",
    depth: 3,
    tags: [
      {aspirations: true},
      {negative: true}
    ]
  },
  {
    id: '2451c83d-88e6-45ad-9c2f-648853758d06',
    img:"http://data.websitebox.com/data/users/0015/580/uploads/VXQ_fireplacejpg.jpg",
    question: "How close and warm is your family? Do you feel your childhood was happier than most other people's?",
    depth: 3,
    tags: [
      {family: true},
      {memory: true}
    ]
  },
  {
    id: '3a1cf290-681a-454f-8858-475f4943d7a1',
    img:"http://www.smallbusinessconnect.org/wp-content/uploads/2016/05/mother-429158_1920.jpg",
    question: "How do you feel about your relationship with your mother?",
    depth: 3,
    tags: [
      {family: true}
    ]
  },
  {
    id: '2d8790dc-e868-4d7d-ac2b-1c881509e17b',
    img:'http://userfiles.steadyhealth.com/userfiles/articles/couple-sunset-talk.jpg',
    question: "Complete this sentence: 'I wish I had someone with whom I could share ... '",
    depth: 3,
    tags: [
      {interests: true}
    ]
  },
  {
    id: '1e24c99c-d001-4d4d-91ae-804afd3e6f96',
    img:'https://image.freepik.com/free-photo/top-view-of-friends-having-fun_1098-980.jpg',
    question: "Tell the person to your right what you like about them; be very honest this time, saying things that you might not say to someone you've just met.",
    depth: 3,
    tags: [
    ]
  },
  {
    id: '12dbc6f3-cb02-4ddc-ac5d-5c94d73b693f',
    img:'https://starpointcounselingcenter.files.wordpress.com/2014/10/1372206815_friend-venting-consoling-11070802.jpg',
    question: "When did you last cry in front of another person? By yourself?",
    depth: 3,
    tags: [
      {negative: true}
    ]
  },
  {
    id: '8ab90458-1d84-4248-b11d-7e9fe82f50b3',
    img:'https://mdhistoricaltrust.files.wordpress.com/2015/02/1-img_7639crop.jpg',
    question: "If you were to die this evening with no opportunity to communicate with anyone, what would you most regret not having told someone? Why haven’t you told them yet?",
    depth: 3,
    tags: [
      {negative: true}
    ]
  },
  {
    id: '5c2e14bc-6e29-45ae-a71e-9d9c23808b4a',
    img:'http://photos.jibble.org/Places/The%20Netherlands/Arnhem%20Oosterbeek%20War%20Cemetary/P1000434%20Gravestones.JPG',
    question: "Of all the people in your family, whose death would you find most disturbing? Why?",
    depth: 3,
    tags: [
      {negative: true}
    ]
  },
  {
    id: 'f214c714-049d-4e8c-b697-b966a1228230',
    img:'http://ell.h-cdn.co/assets/cm/14/52/980x490/549b4f6c36de7_-_elle-code-red-h.jpg',
    question: "Share a personal problem and ask the person to your right’s advice on how he or she might handle it. Also, ask your partner to reflect back to you how you seem to be feeling about the problem you have chosen.",
    depth: 3,
    tags: [
    ]
  } 
]

export default data3;



// WEBPACK FOOTER //
// node_modules/tslint-loader!./src/components/data/level3.tsx